import { apiFetch, saveToken, clearToken } from "@/shared/api/http";

export async function login(email: string, password: string, remember: boolean) {
  const data = await apiFetch<{ ok: boolean; token: string }>("/api/auth/login", {
    method: "POST",
    body: JSON.stringify({ email, password, remember }),
  });
  saveToken(data.token);
  return data;
}

export function logout() {
  clearToken();
  return apiFetch<{ ok: boolean }>("/api/auth/session", { method: "DELETE" }).catch(() => ({ ok: true }));
}

export function getMe() {
  return apiFetch<{ email: string; role: string }>("/api/auth/me");
}

export function getDefaultCredentials() {
  return apiFetch<{ email?: string; password?: string }>("/api/auth/default-login");
}
